import React from 'react';
import propTypes from 'prop-types';
import { RadioButton } from '../leaf-components/RadioButton';

const SearchMethodToggle = ({ searchMethods, selectedSearchMethodId, onSearchMethodChange }) => (
  <fieldset className="cmp-tire-finder__fieldset">
    <legend className="util-visually-hidden">Search Type</legend>
    <div className="cmp-tire-finder__radio-group">
      {searchMethods.map((searchMethod) => {
        const { id, label } = searchMethod;
        return (
          <RadioButton
            key={id}
            id={`tire-finder-search-method-${id}`}
            label={label}
            name="searchMethod"
            value={id}
            checked={id === selectedSearchMethodId}
            onChange={() => onSearchMethodChange(searchMethod)}
          />
        );
      })}
    </div>
  </fieldset>
);

SearchMethodToggle.propTypes = {
  searchMethods: propTypes.arrayOf(propTypes.shape({
    id: propTypes.string,
    label: propTypes.string,
  })),
  selectedSearchMethodId: propTypes.string,
  onSearchMethodChange: propTypes.func,
};

export { SearchMethodToggle };
